import React from "react";
import "./Error.scss";
const Error = () => {
  return (
    <div className="error d-flex flex-column align-items-center justify-content-center">
      <h1 className="error-text text-danger">404</h1>
      <p>Page You are looking For Doesn't Exist</p>
    </div>
  );
};

export default Error;
